// Detect injected wallets — supports Trust Wallet, MetaMask, OKX, Binance, Coinbase, generic injected.
// Returns {provider, name} or null.

export const isMobile = () => {
  if (typeof navigator === 'undefined') return false;
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};

const pickFromProviders = (providers) => {
  // priority: Trust > MetaMask > OKX > Binance > Coinbase > first
  return (
    providers.find((p) => p.isTrust || p.isTrustWallet) ||
    providers.find((p) => p.isMetaMask && !p.isBraveWallet) ||
    providers.find((p) => p.isOkxWallet || p.isOKExWallet) ||
    providers.find((p) => p.isBinance || p.isBinanceWallet) ||
    providers.find((p) => p.isCoinbaseWallet) ||
    providers[0]
  );
};

export const detectInjected = (preferred = 'auto') => {
  if (typeof window === 'undefined' || !window.ethereum) return null;
  const eth = window.ethereum;
  let chosen = eth;

  if (Array.isArray(eth.providers) && eth.providers.length) {
    if (preferred === 'trust') {
      chosen = eth.providers.find((p) => p.isTrust || p.isTrustWallet) || pickFromProviders(eth.providers);
    } else if (preferred === 'metamask') {
      chosen = eth.providers.find((p) => p.isMetaMask && !p.isBraveWallet && !p.isTrust && !p.isTrustWallet) || pickFromProviders(eth.providers);
    } else if (preferred === 'okx') {
      chosen = eth.providers.find((p) => p.isOkxWallet || p.isOKExWallet) || pickFromProviders(eth.providers);
    } else if (preferred === 'binance') {
      chosen = eth.providers.find((p) => p.isBinance || p.isBinanceWallet) || pickFromProviders(eth.providers);
    } else {
      chosen = pickFromProviders(eth.providers);
    }
  }
  if (!chosen) return null;
  return { provider: chosen, name: providerName(chosen) };
};

export const providerName = (p) => {
  if (!p) return 'Wallet';
  if (p.isTrust || p.isTrustWallet) return 'Trust Wallet';
  if (p.isMetaMask) return 'MetaMask';
  if (p.isOkxWallet || p.isOKExWallet) return 'OKX Wallet';
  if (p.isBinance || p.isBinanceWallet) return 'Binance Wallet';
  if (p.isCoinbaseWallet) return 'Coinbase Wallet';
  if (p.isTokenPocket) return 'TokenPocket';
  if (p.isBitKeep) return 'BitKeep';
  return 'Injected Wallet';
};

export const buildTrustDeepLink = () => {
  if (typeof window === 'undefined') return '';
  const url = encodeURIComponent(window.location.href);
  return `https://link.trustwallet.com/open_url?coin_id=20000714&url=${url}`;
};

export const buildMetaMaskDeepLink = () => {
  if (typeof window === 'undefined') return '';
  const host = window.location.host + window.location.pathname + window.location.search;
  return `https://metamask.app.link/dapp/${host}`;
};

export const availableWallets = () => {
  const list = [];
  if (typeof window !== 'undefined' && window.ethereum) {
    const eth = window.ethereum;
    const providers = Array.isArray(eth.providers) && eth.providers.length ? eth.providers : [eth];
    if (providers.some((p) => p.isTrust || p.isTrustWallet)) list.push({ id: 'trust', name: 'Trust Wallet', icon: 'TW' });
    if (providers.some((p) => p.isMetaMask && !p.isBraveWallet)) list.push({ id: 'metamask', name: 'MetaMask', icon: 'MM' });
    if (providers.some((p) => p.isOkxWallet || p.isOKExWallet)) list.push({ id: 'okx', name: 'OKX Wallet', icon: 'OKX' });
    if (providers.some((p) => p.isBinance || p.isBinanceWallet)) list.push({ id: 'binance', name: 'Binance Wallet', icon: 'BNB' });
    if (providers.some((p) => p.isCoinbaseWallet)) list.push({ id: 'coinbase', name: 'Coinbase Wallet', icon: 'CB' });
    if (!list.length) list.push({ id: 'auto', name: providerName(eth), icon: 'W' });
  }
  return list;
};
